module.exports = __webpack_public_path__ + "static/rocketmakers-logo-black-d27c42d30eb4e6c62786f015ca66353a.svg";